/**
 * All Words Pack - Mixed length words (5-10 letters)
 * Combines all word lists for varied gameplay experience
 */

import { WordPack } from '../../types/GameTypes';
import words5 from '../words-5';
import words6 from '../words-6';
import words7 from '../words-7';
import words8 from '../words-8';
import words9 from '../words-9';
import words10 from '../words-10';

const allWordsPack: WordPack = {
  id: 'all-words',
  name: 'All Words (5-10 Letters)',
  description: 'Mixed word lengths for varied gameplay - the classic RSTLNE experience',
  difficulty: 'medium',
  words: [...words5, ...words6, ...words7, ...words8, ...words9, ...words10]
};

export default allWordsPack;